// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.tariff-confirm-table > thead > tr.header-row > th {
  font: bold 13px/15px "Roboto";
  letter-spacing: 0.22px;
  color: #FFF;
  background-color: #0b4323;
  top: 0;
  position: sticky;
  border: none;
}

table.tariff-confirm-table > thead > tr.header-row > th.total-due {
  background-color: #92c46d;
}

table.tariff-confirm-table > tbody > tr.data-row:nth-child(even) {
  font: normal 12px/15px "Roboto";
  letter-spacing: 0.22px;
  color: #424242;
  background-color: #f4f4f4;
}

table.tariff-confirm-table > tbody > tr.data-row > td {
  border: none;
}

table.tariff-confirm-table > tbody > tr.data-row > td.total-due {
  font: bold 13px/15px "Roboto";
  letter-spacing: 0.22px;
  color: #FFF;
}

table.tariff-confirm-table > tbody > tr.data-row:nth-child(odd) > td.total-due {
  background-color: #92c46d;
}

table.tariff-confirm-table > tbody > tr.data-row:nth-child(even) > td.total-due {
  background-color: #82c44c;
}`, "",{"version":3,"sources":["webpack://./src/style/transformer/ConfirmCapturing.scss"],"names":[],"mappings":"AAKA;EACI,6BAAA;EACA,sBAAA;EACA,WAAA;EACA,yBATiB;EAUjB,MAAA;EACA,gBAAA;EACA,YAAA;AAJJ;;AAOA;EACI,yBAfkB;AAWtB;;AAOA;EACI,+BAAA;EACA,sBAAA;EACA,cAAA;EACA,yBArBa;AAiBjB;;AAOA;EACI,YAAA;AAJJ;;AAOA;EACI,6BAAA;EACA,sBAAA;EACA,WAAA;AAJJ;;AAOA;EACI,yBApCkB;AAgCtB;;AAOA;EACI,yBAtCuB;AAkC3B","sourcesContent":["$COLOR_PRIMARY_DARK: get('colors.material.primary.dark');\n$COLOR_TOTAL_INVOICE: get('colors.table.capturing.lpu.invoiceTotal');\n$COLOR_EVEN_ROW: get('colors.table.capturing.lpu.evenRow');\n$COLOR_TOTAL_INVOICE_EVEN: get('colors.table.capturing.lpu.invoiceTotalEven');\n\ntable.tariff-confirm-table > thead > tr.header-row > th {\n    font: bold 13px/15px 'Roboto';\n    letter-spacing: 0.22px;\n    color: #FFF;\n    background-color: $COLOR_PRIMARY_DARK;\n    top: 0;\n    position: sticky;\n    border: none;\n}\n\ntable.tariff-confirm-table > thead > tr.header-row > th.total-due {\n    background-color: $COLOR_TOTAL_INVOICE;\n}\n\ntable.tariff-confirm-table > tbody > tr.data-row:nth-child(even) {\n    font: normal 12px/15px 'Roboto';\n    letter-spacing: 0.22px;\n    color: #424242;\n    background-color: $COLOR_EVEN_ROW;\n}\n\ntable.tariff-confirm-table > tbody > tr.data-row > td {\n    border: none;\n}\n\ntable.tariff-confirm-table > tbody > tr.data-row > td.total-due {\n    font: bold 13px/15px 'Roboto';\n    letter-spacing: 0.22px;\n    color: #FFF;\n}\n\ntable.tariff-confirm-table > tbody > tr.data-row:nth-child(odd) > td.total-due {\n    background-color: $COLOR_TOTAL_INVOICE;\n}\n\ntable.tariff-confirm-table > tbody > tr.data-row:nth-child(even) > td.total-due {\n    background-color: $COLOR_TOTAL_INVOICE_EVEN;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
